import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsChucVuDoan } from '../../services/danhmuc';

const ChucVuDoanSelectBox = ({ disabled, onChange }: { disabled?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsChucVuDoan(); 
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn chức vụ Đoàn--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        name: name,
                        value: e
                    }
                })
            }}
            disabled={disabled}
            allowClear
        />
    );
};

export default ChucVuDoanSelectBox;
